import StackedLayout from './StackedLayout';

export default StackedLayout;
